module.exports = __webpack_public_path__ + "img/battery-crossed.ea8642ca.svg";